/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const textEditorSlice = createSlice({
  name: 'textEditor',
  initialState: {
    activeVersionIndex: 0,
    diffMode: false,
    currentResourceId: null,
    versions: [],
    currentVersionId: null,
    resolvedAnnotation: null,
    annotationListCacheBust: false,
    commentListCacheBust: null,
    filterState: 'All comments'
  },
  reducers: {
    updateActiveVersionIndex(state, action) {
      const index = action.payload;
      state.activeVersionIndex = index;
    },
    toggleDiffMode(state, action) {
      const diffMode = action.payload;
      state.diffMode = !diffMode;
    },
    setResourceId(state, action) {
      const currentResourceId = action.payload;
      state.currentResourceId = currentResourceId;
    },
    setVersionId(state, action) {
      const currentVersionId = action.payload;
      state.currentVersionId = currentVersionId;
    },
    updateVersions(state, action) {
      const versions = action.payload;
      const stateVersions = state.versions;
      if (
        stateVersions.length === 0 ||
        versions.length === 0 ||
        stateVersions[stateVersions.length - 1].end !== versions[versions.length - 1].end
      ) {
        state.versions = versions;
      }
    },
    updateResolvedAnnotation(state, action) {
      const resolvedAnnotation = action.payload;
      state.resolvedAnnotation = resolvedAnnotation;
    },
    updateAnnotationListCacheBust(state, action) {
      const annotationListCacheBust = action.payload;
      state.annotationListCacheBust = annotationListCacheBust;
    },
    updateCommentListCacheBust(state, action) {
      const commentListCacheBust = action.payload;
      state.commentListCacheBust = commentListCacheBust;
    },
    updateFilterState(state, action) {
      const filterState = action.payload;
      state.filterState = filterState;
    }
  }
});

const { actions, reducer } = textEditorSlice;

export const {
  updateActiveVersionIndex,
  toggleDiffMode,
  setResourceId,
  updateVersions,
  setVersionId,
  updateResolvedAnnotation,
  updateAnnotationListCacheBust,
  updateCommentListCacheBust,
  updateFilterState
} = actions;
export default reducer;



// WEBPACK FOOTER //
// ./app/javascript/client/store/textEditorReducer.js